import React from "react";
import { Link } from "react-router-dom";
import { LogOut, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const DashboardHeader = ({ title, subtitle }) => {
  const { user, logout } = useAuth();
  return (
    <header className="border-b border-slate-200 bg-white/80 backdrop-blur-xl sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="dashboard-home-link" className="flex items-center gap-2">
          <span className="inline-flex h-9 w-9 rounded-2xl bg-[#0A192F] text-white font-display font-extrabold items-center justify-center">B</span>
          <span className="font-display font-bold text-[#0A192F] tracking-tight">BoxB<span className="text-[#2563EB]">.</span></span>
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <div className="hidden sm:flex items-center gap-2 pr-3 border-r border-slate-200">
              {user.picture ? (
                <img src={user.picture} alt="" className="h-8 w-8 rounded-full" />
              ) : (
                <span className="h-8 w-8 rounded-full bg-gradient-to-br from-[#0A192F] to-[#2563EB] text-white inline-flex items-center justify-center text-sm font-bold">
                  {(user.name || user.email || "?")[0].toUpperCase()}
                </span>
              )}
              <div className="text-right">
                <div data-testid="dashboard-user-name" className="text-sm font-semibold text-[#0A192F] leading-tight">{user.name || user.email}</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider font-bold">{user.role}</div>
              </div>
            </div>
          )}
          <Link to="/" className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-[#0A192F]">
            <Home className="h-4 w-4" /> <span className="hidden sm:inline">Site</span>
          </Link>
          <button data-testid="logout-btn" onClick={logout}
                  className="inline-flex items-center gap-1 rounded-full bg-[#0A192F] text-white px-4 py-2 text-sm font-semibold hover:bg-[#0F172A] transition-all">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
      {(title || subtitle) && (
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
          {title && <h1 className="font-display font-semibold text-3xl sm:text-4xl text-[#0A192F] tracking-tight">{title}</h1>}
          {subtitle && <p className="mt-2 text-slate-600">{subtitle}</p>}
        </div>
      )}
    </header>
  );
};
